












































import gql from 'graphql-tag'
import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppTitleBar from '@/components/AppTitleBar.vue'
import { CURRENT_USER } from '@/gql/auth'
import { MY_USER } from '@/gql/user'
import { Common, ScrollToFetch } from '@/mixins'

@Component({
  components: {
    AppTitleBar
  },
  apollo: {
    currentUser: {
      query: CURRENT_USER
    },
    myUser: {
      query: MY_USER,
      skip () { return !this.currentUser },
      variables () { return { username: this.currentUser.username } }
    },
    confirmedOrderItemConnection: {
      query: gql`query confirmedOrderItemConnection($after: String) {
        confirmedOrderItemConnection(after: $after) {
          cursor
          hasNextPage
          orderItems {
            id
            item {
              id
              name
              price
              usingPepperService
              maxCommissionRate
              medias {
                id
                path
              }
              seller {
                id
                username
                shop {
                  id
                  shoppingMallName
                }
              }
            }
          }
        }
      }`
    }
  }
})
export default class extends Mixins(Common, ScrollToFetch) {
  @Prop(Array) readonly itemIds!: string[]
  confirmedOrderItemConnection: {
    orderItems: { id: string; item: { id: string } }[];
  } = { orderItems: [] }

  currentUser: { id: string } | null = null
  myUser = {}
  idsSelected: string[] = []

  mounted () {
    this.idsSelected = [...this.itemIds]
    this.addScrollListener('confirmedOrderItemConnection', 'orderItems')
  }

  get distinctItems () {
    const orderItems = this.confirmedOrderItemConnection.orderItems
    return orderItems.filter(
      (orderItem, position) => orderItems.findIndex(oi => oi.item.id === orderItem.item.id) === position
    ).map(orderItem => orderItem.item)
  }

  onClickItem (id: string) {
    const index = this.idsSelected.indexOf(id)
    if (index > -1) {
      this.idsSelected.splice(index, 1)
    } else {
      this.idsSelected.push(id)
    }
  }

  getRank (id: string) {
    const index = this.idsSelected.indexOf(id)
    return index > -1 ? index + 1 : ''
  }

  beforeDestroy () {
    window.onscroll = null
  }
}
